/**
 * Publication
 */
import React from 'react';
import { Icon } from 'ui-component-library/base';
import Button from 'ui-component-library/base/Button';
/** Publication component for each single publication */
var Publication = function (_a) {
    var image = _a.image, alt = _a.alt, downloadText = _a.downloadText, publicationUrl = _a.publicationUrl, children = _a.children;
    return (React.createElement("div", { "data-cid": "Publication", className: "bg-greyLighter p-4 md:p-2 rounded relative" },
        React.createElement("div", { className: "flex min-h-52 md:min-h-32" },
            image && alt && (React.createElement("div", { className: "h-20 w-15 md:w-25 md:h-32 min-w-15 md:min-w-25" },
                React.createElement("img", { height: "128", width: "100", loading: "lazy", src: image + '?width=100', alt: alt, className: "h-full image__object-fit mb-0" }))),
            children && React.createElement("dl", { className: "flex flex-col ml-4" }, children)),
        downloadText && publicationUrl && (React.createElement("div", { className: "flex justify-center md:inline-block md:absolute bottom-0 right-0 mt-4 md:mt-0 md:mb-3 md:mr-3" },
            React.createElement(Button, { as: "a", href: publicationUrl, download: true },
                downloadText,
                React.createElement(Icon, { icon: "download", className: "ml-2", "aria-hidden": true }))))));
};
export default Publication;
